import { render, staticRenderFns } from "./Clipper.vue?vue&type=template&id=9a7a4814&scoped=true&"
import script from "./Clipper.vue?vue&type=script&lang=js&"
export * from "./Clipper.vue?vue&type=script&lang=js&"
import style0 from "./Clipper.vue?vue&type=style&index=0&id=9a7a4814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7a4814",
  null
  
)

export default component.exports